import styled from 'styled-components';
import { Button, TransparentButton } from '../../utils/Button/Button';
import { Text14Bold, Text14Regular } from '../../utils/Text/Text.styles';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 0.8rem;
`;

export const Paragraph = styled(Text14Regular)`
  color: #040209;
  line-height: 1.6;
`;

export const SectionTitle = styled(Text14Bold)`
  color: #040209;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
  padding-left: 2rem;
`;

export const ListItem = styled.li`
  color: #040209;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.6;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.2rem;
  margin-top: 0.4rem;

  @media only screen and (max-width: 600px) {
    flex-direction: column-reverse;
  }
`;

export const CloseButton = styled(TransparentButton)`
  width: 14rem;
  border: 1px solid #d7dbe0;
  color: #040209;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const UnderstandButton = styled(Button)`
  width: 16rem;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const IdVerificationContent = styled.div`
  min-height: 14rem;
`;
